var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMuyBien(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16ZM16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.756 21.5H14.2438C14.2521 21.5176 14.2606 21.5352 14.2693 21.5528C14.3975 21.8092 14.5741 22.0351 14.8202 22.1992C15.0601 22.3591 15.4249 22.5 15.9999 22.5C16.5749 22.5 16.9397 22.3591 17.1796 22.1992C17.4257 22.0351 17.6023 21.8092 17.7305 21.5528C17.7393 21.5352 17.7478 21.5176 17.756 21.5ZM11.9999 20.5101C11.9999 20.5045 11.9999 20.501 11.9999 20.501L11.9999 20.5021L11.9999 20.5045L11.9999 20.5101L12.0001 20.5247C12.0003 20.536 12.0006 20.5501 12.0012 20.567C12.0023 20.6008 12.0044 20.6457 12.0083 20.7002C12.0161 20.8088 12.0311 20.9574 12.0604 21.1331C12.1182 21.4799 12.2356 21.9575 12.4805 22.4472C12.7273 22.9408 13.1132 23.4649 13.7108 23.8633C14.3147 24.2659 15.0749 24.5 15.9999 24.5C16.9249 24.5 17.6851 24.2659 18.289 23.8633C18.8866 23.4649 19.2725 22.9408 19.5193 22.4472C19.7642 21.9575 19.8816 21.4799 19.9394 21.1331C19.9687 20.9574 19.9837 20.8088 19.9915 20.7002C19.9954 20.6457 19.9975 20.6008 19.9986 20.567C19.9992 20.5501 19.9995 20.536 19.9997 20.5247L19.9999 20.5101L19.9999 20.5045L19.9999 20.5021L19.9999 20.501L20 20.5C20 19.9477 19.5522 19.5 18.9999 19.5H12.9999C12.4476 19.5 11.9999 19.9477 11.9999 20.5L11.9999 20.5101Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMuyBien);
export default __webpack_public_path__ + "static/media/Ic_Muy Bien.61a31828e5db8df68ab8ad00c4929aa0.svg";
export { ForwardRef as ReactComponent };